import React from 'react';

export const NurIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2017 14.85L13.7935 7.13574L9.38574 14.85H18.2017Z"
      fill="#FECC04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 18L18.2002 14.8501H9.38563L13.7929 7.13724L12 4L4 18H20Z"
      fill="#0066B3"
    />
  </svg>
);
